package org.catharsis.spendtel.core.platform

data class PickedStatementFile(
    val fileName: String,
    val mimeType: String,
    val bytes: ByteArray,
    val sizeBytes: Long = bytes.size.toLong(),
) {
    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other == null || this::class != other::class) return false
        other as PickedStatementFile
        return fileName == other.fileName &&
            mimeType == other.mimeType &&
            bytes.contentEquals(other.bytes) &&
            sizeBytes == other.sizeBytes
    }

    override fun hashCode(): Int {
        var result = fileName.hashCode()
        result = 31 * result + mimeType.hashCode()
        result = 31 * result + bytes.contentHashCode()
        result = 31 * result + sizeBytes.hashCode()
        return result
    }
}

expect suspend fun pickStatementDocuments(): Result<List<PickedStatementFile>>
